module.exports = __webpack_public_path__ + "img/status_diagram.2079a719.png";